// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2pDn1","error":"Textarea_error__3TqiA","readonly":"Textarea_readonly__Y2TMx","disabled":"Textarea_disabled__1R0gW"};